import { type Images } from '@neos/app'
import aiWritingAssistantPath from '../../modules/dependencies/NeosAICore/images/AIWritingAssistant.svg'
import aiWritingAssistantDarkVersionPath from '../../modules/dependencies/NeosAICore/images/AIWritingAssistant.dark.svg'
import aiWritingAssistantTaskPerformerPath from '../../modules/dependencies/NeosAICore/images/AIWritingAssistantTaskPerformer.svg'
import chatbotPath from '../../modules/Licensing/images/Chatbot.svg'
import collapsePath from '../../modules/dependencies/UserPermissions/images/Collapse.svg'
import commercialSolutionPath from '../../modules/Licensing/images/CommercialSolution.svg'
import correctTextPath from '../../modules/dependencies/NeosAICore/images/CorrectText.svg'
import createCustomViewPath from '../../modules/dependencies/UICustomization/images/CreateCustomView.svg'
import createCustomViewDarkVersionPath from '../../modules/dependencies/UICustomization/images/CreateCustomView.dark.svg'
import customViewPath from '../../modules/dependencies/UICustomization/images/CustomView.svg'
import customViewDefaultViewPath from '../../modules/dependencies/UICustomization/images/CustomViewDefaultView.svg'
import customViewFilterPath from '../../modules/dependencies/UICustomization/images/CustomViewFilter.svg'
import customViewGroupsPath from '../../modules/dependencies/UICustomization/images/CustomViewGroups.svg'
import customViewKeyPath from '../../modules/dependencies/UICustomization/images/CustomViewKey.svg'
import customViewPropertyPath from '../../modules/dependencies/UICustomization/images/CustomViewProperty.svg'
import customViewRelationshipPath from '../../modules/dependencies/UICustomization/images/CustomViewRelationship.svg'
import customViewSavePath from '../../modules/dependencies/UICustomization/images/CustomViewSave.svg'
import customViewSelectedPath from '../../modules/dependencies/UICustomization/images/CustomViewSelected.svg'
import customViewSetDefaultViewPath from '../../modules/dependencies/UICustomization/images/CustomViewSetDefaultView.svg'
import customViewSortPath from '../../modules/dependencies/UICustomization/images/CustomViewSort.svg'
import customerPath from '../../modules/Licensing/images/Customer.svg'
import downPath from '../../modules/dependencies/UserPermissions/images/Down.svg'
import editCustomViewPath from '../../modules/dependencies/UICustomization/images/EditCustomView.svg'
import editCustomViewDarkVersionPath from '../../modules/dependencies/UICustomization/images/EditCustomView.dark.svg'
import errorClusterPath from '../../modules/dependencies/UserPermissions/images/ErrorCluster.svg'
import expandPath from '../../modules/dependencies/UserPermissions/images/Expand.svg'
import externalClusterPath from '../../modules/dependencies/UserPermissions/images/ExternalCluster.svg'
import featurePath from '../../modules/Licensing/images/Feature.svg'
import improveTextPath from '../../modules/dependencies/NeosAICore/images/ImproveText.svg'
import licensePath from '../../modules/Licensing/images/License.svg'
import listPath from '../../modules/Licensing/images/List.svg'
import metricPath from '../../modules/Licensing/images/Metric.svg'
import modulePath from '../../modules/Licensing/images/Module.svg'
import modulesPath from '../../modules/Licensing/images/Modules.svg'
import neosPath from '../../modules/Licensing/images/Neos.svg'
import omniaPath from '../../modules/dependencies/NeosAICore/images/Omnia.svg'
import performTaskOnTextPath from '../../modules/dependencies/NeosAICore/images/PerformTaskOnText.svg'
import queryaPath from '../../modules/dependencies/NeosAICore/images/Querya.svg'
import quickActionsPath from '../../modules/dependencies/NeosAICore/images/QuickActions.svg'
import roleUsersPath from '../../modules/dependencies/UserPermissions/images/RoleUsers.svg'
import settingsPath from '../../modules/Licensing/images/Settings.svg'
import shortenTextPath from '../../modules/dependencies/NeosAICore/images/ShortenText.svg'
import solutionsPath from '../../modules/Licensing/images/Solutions.svg'
import styleRulePath from '../../modules/dependencies/UICustomization/images/StyleRule.svg'
import styleRuleDarkVersionPath from '../../modules/dependencies/UICustomization/images/StyleRule.dark.svg'
import syncBlackPath from '../../modules/dependencies/UserPermissions/images/SyncBlack.svg'
import technicalFunctionPath from '../../modules/Licensing/images/TechnicalFunction.svg'
import translatorPath from '../../modules/dependencies/NeosAICore/images/Translator.svg'
import upPath from '../../modules/dependencies/UserPermissions/images/Up.svg'
import userAccountPath from '../../modules/dependencies/UserPermissions/images/UserAccount.svg'
import userClientPath from '../../modules/dependencies/UserPermissions/images/UserClient.svg'
import userFunctionPath from '../../modules/dependencies/UserPermissions/images/UserFunction.svg'
import userPermissionsSendEmailPath from '../../modules/dependencies/UserPermissions/images/UserPermissionsSendEmail.svg'
import userPermissionsSendSMSPath from '../../modules/dependencies/UserPermissions/images/UserPermissionsSendSMS.svg'
import userPublisherPath from '../../modules/dependencies/UserPermissions/images/UserPublisher.svg'
import volumetryPath from '../../modules/Licensing/images/Volumetry.svg'
import volumetryDesignationPath from '../../modules/Licensing/images/VolumetryDesignation.svg'

const images: Images = {
  aiWritingAssistant: { path: aiWritingAssistantPath, darkVersionPath: aiWritingAssistantDarkVersionPath, colored: true },
  aiWritingAssistantCancel: 'close',
  aiWritingAssistantTaskPerformer: { path: aiWritingAssistantTaskPerformerPath, colored: false },
  aiWritingAssistantValidate: 'validate',
  chatbot: { path: chatbotPath, colored: true },
  collapse: { path: collapsePath, colored: false },
  commercialSolution: { path: commercialSolutionPath, colored: false },
  correctText: { path: correctTextPath, colored: false },
  createCustomView: { path: createCustomViewPath, darkVersionPath: createCustomViewDarkVersionPath, colored: true },
  customView: { path: customViewPath, colored: false },
  customViewDefaultView: { path: customViewDefaultViewPath, colored: false },
  customViewFilter: { path: customViewFilterPath, colored: false },
  customViewGroups: { path: customViewGroupsPath, colored: false },
  customViewKey: { path: customViewKeyPath, colored: false },
  customViewProperty: { path: customViewPropertyPath, colored: false },
  customViewRelationship: { path: customViewRelationshipPath, colored: false },
  customViewSave: { path: customViewSavePath, colored: false },
  customViewSelected: { path: customViewSelectedPath, colored: false },
  customViewSetDefaultView: { path: customViewSetDefaultViewPath, colored: false },
  customViewSort: { path: customViewSortPath, colored: false },
  customer: { path: customerPath, colored: false },
  dataCreator: 'add',
  down: { path: downPath, colored: false },
  edit: 'edit',
  editCustomView: { path: editCustomViewPath, darkVersionPath: editCustomViewDarkVersionPath, colored: true },
  editUser: 'edit',
  error: 'error',
  errorCluster: { path: errorClusterPath, colored: true },
  expand: { path: expandPath, colored: false },
  externalCluster: { path: externalClusterPath, colored: true },
  feature: { path: featurePath, colored: false },
  improveText: { path: improveTextPath, colored: false },
  info: 'info',
  license: { path: licensePath, colored: false },
  list: { path: listPath, colored: false },
  menu: 'menu',
  metric: { path: metricPath, colored: false },
  module: { path: modulePath, colored: false },
  modules: { path: modulesPath, colored: false },
  neos: { path: neosPath, colored: true },
  neosPrint: 'print',
  omnia: { path: omniaPath, colored: true },
  performTaskOnText: { path: performTaskOnTextPath, colored: false },
  querya: { path: queryaPath, colored: true },
  quickActions: { path: quickActionsPath, colored: false },
  roleUsers: { path: roleUsersPath, colored: false },
  settings: { path: settingsPath, colored: false },
  shortenText: { path: shortenTextPath, colored: false },
  solutions: { path: solutionsPath, colored: false },
  styleRule: { path: styleRulePath, darkVersionPath: styleRuleDarkVersionPath, colored: true },
  syncBlack: { path: syncBlackPath, colored: false },
  technicalFunction: { path: technicalFunctionPath, colored: false },
  translator: { path: translatorPath, colored: false },
  up: { path: upPath, colored: false },
  userAccount: { path: userAccountPath, colored: false },
  userClient: { path: userClientPath, colored: false },
  userFunction: { path: userFunctionPath, colored: false },
  userPermissionsSendEmail: { path: userPermissionsSendEmailPath, colored: false },
  userPermissionsSendSMS: { path: userPermissionsSendSMSPath, colored: false },
  userPublisher: { path: userPublisherPath, colored: false },
  vasco: 'open',
  volumetry: { path: volumetryPath, colored: false },
  volumetryDesignation: { path: volumetryDesignationPath, colored: false },
  warning: 'warning',
}

export default images